import React from 'react'

const close = () => (
  <svg width="22" height="22" viewBox="0 0 22 22">
    <path fill="#242C6C" fillRule="evenodd" d="M621 17.077L618.923 15 610.047 23.876 601.077 15 599 17.077 607.876 26.047 599 34.923 601.077 37 610.047 28.124 618.923 37 621 34.923 612.124 26.047z" transform="translate(-599 -15)"/>
  </svg>
)

export default close
